// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IgRC","content":"styles_content__3l6Vu","tableWrap":"styles_tableWrap__KZRgg"};